export interface BrowserInfo {
  browserName: string;
  browserVersion: string;
  userAgent: string;
  platform: string;
  screenResolution: string;
  language: string;
}

const UNKNOWN = 'unknown';

export const getBrowserInfo = (): BrowserInfo => {
  const userAgent = navigator.userAgent;
  const browserInfo =
    userAgent.match(/(chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  const platform = navigator.platform;
  const screenResolution = `${window.screen.width}x${window.screen.height}`;
  const language = navigator.language || navigator.languages[0];

  return {
    browserName: browserInfo[1] || UNKNOWN,
    browserVersion: browserInfo[2] || UNKNOWN,
    userAgent,
    platform,
    screenResolution,
    language,
  };
};
